import React from 'react';
import { Reveal } from './Reveal';
import { kitContents } from '../data/kitContents';
export function KitContentsSection() {
  return <section className="bg-sand px-4 py-16 md:py-24" data-id="element-123" data-mp="209o2oa1qn9ku">
      <Reveal className="mx-auto max-w-6xl" data-id="element-124" data-mp="257pnazetbgyf">
        <div className="mx-auto mb-12 max-w-2xl text-center" data-id="element-125" data-mp="256o1q1067c2g">
          <p className="mb-4 font-note text-[10px] font-semibold tracking-[0.24em] text-sage sm:text-xs" data-id="element-126" data-mp="2a7lqwxjll6dg">
            COSA CONTIENE
          </p>
          <h2 className="text-3xl font-bold tracking-tight text-petrol md:text-4xl" data-id="element-127" data-mp="2f66jcaslylrc">
            Cosa c&apos;è dentro Pilates Reformer Pronto
          </h2>
        </div>
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-128" data-mp="2o01mxee3044v">
          {kitContents.map(({
          icon: ContentIcon,
          title,
          description
        }) => <article key={title} className="flex flex-col rounded-xl border border-line bg-white p-7 text-center shadow-soft" data-id="element-129" data-mp="2sznzrmpzzid5">
              <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-sage/10 text-sage" data-id="element-130" data-mp="32wiurvn2b0mo">
                <ContentIcon className="h-6 w-6" strokeWidth={1.6} aria-hidden="true" data-id="element-131" data-mp="10jj9tsyc7q24" />
              </span>
              <h3 className="mt-5 font-heading text-lg font-semibold text-petrol" data-id="element-132" data-mp="vovtwiheg3z5">{title}</h3>
              <p className="mt-2.5 text-sm leading-relaxed text-muted" data-id="element-133" data-mp="qp9hucdb4trx">{description}</p>
            </article>)}
        </div>
      </Reveal>
    </section>;
}